export default "__VITE_ASSET__BFptU1JV__"